import React from 'react';
import { Alert, Label } from 'reactstrap';
import FormikInputField from '~/components/formikInputField/formikInputField';
import SubmissionButton from '~/components/submissionButton/submissionButton';
import FormLayout from '~/components/formLayout/formLayout';

const VesselTypeForm = ({ errors, touched, handleSubmit, isSubmitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
      <FormLayout title="Overview" className="mb3">
        <div className="mb3">
          <Label>Name</Label>
          <FormikInputField name="name" invalid={!!errors.name} />
          {errors.name && (
            <p data-qa="name-error" className="error">
              {errors.name}
            </p>
          )}
        </div>
        <div className="mb3">
          <Label>Description</Label>
          <FormikInputField type="textarea" name="description" />
        </div>
      </FormLayout>
      <FormLayout title="Amount">
        <div className="flex flex-column flex-row-ns">
          <div className="mb3 mr3">
            <Label>Volume (L)</Label>
            <FormikInputField name="volume" step=".01" type="number" invalid={!!errors.volume} />
            {errors.volume && <p className="error">{errors.volume}</p>}
          </div>
          <div className="mb3">
            <Label>Quantity</Label>
            <FormikInputField name="quantity" type="number" invalid={!!errors.quantity} />
            {errors.quantity && <p className="error">{errors.quantity}</p>}
          </div>
        </div>
      </FormLayout>
      <div className="flex justify-end mt4">
        <SubmissionButton color="primary" type="submit" isSubmitting={isSubmitting}>
          Save
        </SubmissionButton>
      </div>
    </form>
  );
};

export default VesselTypeForm;



// WEBPACK FOOTER //
// ./src/components/vesselTypeForm/vesselTypeForm.jsx